<template>
  <div>
    <div class="job_card_list">

      <div class="job_card" v-for="(item, i) in job_list" :key="i">
        <div class="job_card_option">
          <span class="editor_span" @click="click_editor_job(item)">
            <Icon type="ios-create-outline" />
          </span>
          <span class="close_span" @click="click_close_job(item)">
            <Icon type="md-close" />
          </span>
        </div>
        <div>
          <span class="job_name">{{ item.job_name }}</span>

        </div>
        <div @click="click_item(item, i)">
          <div class="job_status_fmt">
            岗位类型：{{ item.job_status_fmt }}
          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'xiaoshi'">
            发放价格：<span class="job_moeny">￥{{ item.is_hide == 1 ? '****' : item.fafang_money }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />
          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'xiaoshi'">
            结算价格：<span class="job_moeny">￥{{ item.is_hide == 1 ? '****' : item.jiesuan_money }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'xiaoshi'">
            结算含税：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.xiaoshigong_tax_status_fmt }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <!-- 派遣 -->
          <div class="job_status_fmt" v-if="item.job_status == 'paiqian'">
            服务费：<span class="job_moeny">￥{{ item.is_hide == 1 ? '****' : item.fuwu_money }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'paiqian'">
            服务费含税：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.fuwu_tax_status_fmt }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'paiqian'">
            服务费说明：<span class="job_moeny" :title="item.fuwu_desc">{{
              item.fuwu_desc.length > 6 ? item.fuwu_desc.slice(0, 6) + '..' : item.fuwu_desc }}</span>

          </div>
          <!-- 社保代理 -->
          <div class="job_status_fmt" v-if="item.job_status == 'shebaodaili'">
            服务费：<span class="job_moeny">￥{{ item.is_hide == 1 ? '****' : item.fuwu_money }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'shebaodaili'">
            服务费含税：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.fuwu_tax_status_fmt }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'shebaodaili'">
            服务费说明：<span class="job_moeny" :title="item.fuwu_desc">{{
              item.fuwu_desc.length > 6 ? item.fuwu_desc.slice(0, 6) + '..' : item.fuwu_desc }}</span>
          </div>
          <!-- 代发工资 -->
          <div class="job_status_fmt" v-if="item.job_status == 'daifagongzi'">
            服务费：<span class="job_moeny">￥{{ item.is_hide == 1 ? '****' : item.fuwu_money }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'daifagongzi'">
            服务费含税：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.fuwu_tax_status_fmt }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'daifagongzi'">
            服务费说明：<span class="job_moeny" :title="item.fuwu_desc">{{
              item.fuwu_desc.length > 6 ? item.fuwu_desc.slice(0, 6) + '..' : item.fuwu_desc }}</span>
          </div>
          <!-- 计件 -->
          <div class="job_status_fmt" v-if="item.job_status == 'jijian'">
            结算比例：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.jijian_jiesuan_ratio }}倍</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>
          <div class="job_status_fmt" v-if="item.job_status == 'jijian'">
            结算价含税：<span class="job_moeny">{{ item.is_hide == 1 ? '****' : item.jijian_tax_status_fmt }}</span>
            <Icon class="hide_icon" v-if="item.is_hide == 1" type="ios-eye-off" />

          </div>

        </div>

      </div>
      <div class="add_job_txt" v-if="job_list.length == 0">
        暂无在招岗位，请及时添加！
      </div>

      <div class="job_card_add" @click="zhudong_add_job">
        <Icon class="add_icon" type="ios-add-circle" color="#0466dd" size="16" />&nbsp;添加
      </div>
    </div>


    <Modal draggable v-model="add_job_show" :title="add_job_model_title" :mask-closable="false" width="500"
      @on-ok="add_job_confirm">
      <div class="job_name_div">
        <div class="input_job_name">岗位类型</div>
        <Select v-model="add_job_data.job_status" style="width:400px">
          <Option v-for="item in job_status_options" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>


      <div class="job_name_div">
        <div class="input_job_name">岗位名称（标签）</div>
        <Input v-model="add_job_data.job_name" placeholder="岗位标签，用于区分岗位类型，例：装配工(第一批)" style="width: 340px" />
      </div>

      <div class="job_name_div" v-if="add_job_data.job_status == 'xiaoshi'">
        <div class="input_job_name">员工发放价</div>
        <Input v-model="add_job_data.fafang_money" placeholder="请输入发放员工的价格。例: 22" style="width: 300px" /> &nbsp;元

      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'xiaoshi'">
        <div class="input_job_name">公司结算价</div>
        <Input v-model="add_job_data.jiesuan_money" placeholder="请输入项目结算价格。例: 23.5" style="width: 300px" /> &nbsp;元
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'xiaoshi'">
        <div class="input_job_name">结算价是否含税</div>
        <Select v-model="add_job_data.xiaoshigong_tax_status" style="width:200px">
          <Option v-for="item in xiaoshigong_jiesuan_options" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>


      <div class="job_name_div" v-if="add_job_data.job_status == 'paiqian'">
        <div class="input_job_name">服务费/人</div>
        <Input v-model="add_job_data.fuwu_money" placeholder="请输入项目结算的服务费。例: 150" style="width: 300px" /> &nbsp;元
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'paiqian'">
        <div class="input_job_name">服务费说明</div>
        <Input v-model="add_job_data.fuwu_desc" placeholder="请输入服务费结算说明。例：前7天xxx..." style="width: 340px" /> &nbsp;
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'paiqian'">
        <div class="input_job_name">服务费是否含税</div>
        <Select v-model="add_job_data.fuwu_tax_status" style="width:200px">
          <Option v-for="item in fuwu_jiesuan_options" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>

      <div class="job_name_div" v-if="add_job_data.job_status == 'jijian'">
        <div class="input_job_name">计件结算比例</div>
        <Input v-model="add_job_data.jijian_jiesuan_ratio" placeholder="请输入结算比例。例：1.5倍就填1.5" style="width: 340px" />
        &nbsp;
      </div>

      <div class="job_name_div" v-if="add_job_data.job_status == 'jijian'">
        <div class="input_job_name">结算价是否含税</div>
        <Select v-model="add_job_data.jijian_tax_status" style="width:200px">
          <Option v-for="item in fuwu_jiesuan_options" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>

      <div class="job_name_div" v-if="add_job_data.job_status == 'shebaodaili'">
        <div class="input_job_name">服务费/人</div>
        <Input v-model="add_job_data.fuwu_money" placeholder="请输入服务费。例: 150" style="width: 300px" /> &nbsp;元
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'shebaodaili'">
        <div class="input_job_name">服务费说明</div>
        <Input v-model="add_job_data.fuwu_desc" placeholder="请输入服务费结算说明。例：前7天xxx..." style="width: 340px" /> &nbsp;
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'shebaodaili'">
        <div class="input_job_name">服务费是否含税</div>
        <Select v-model="add_job_data.fuwu_tax_status" style="width:200px">
          <Option v-for="item in fuwu_jiesuan_options" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>

      <div class="job_name_div" v-if="add_job_data.job_status == 'daifagongzi'">
        <div class="input_job_name">服务费/人</div>
        <Input v-model="add_job_data.fuwu_money" placeholder="请输入服务费。例: 150" style="width: 300px" /> &nbsp;元
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'daifagongzi'">
        <div class="input_job_name">服务费说明</div>
        <Input v-model="add_job_data.fuwu_desc" placeholder="请输入服务费结算说明。例：前7天xxx..." style="width: 340px" /> &nbsp;
      </div>
      <div class="job_name_div" v-if="add_job_data.job_status == 'daifagongzi'">
        <div class="input_job_name">服务费是否含税</div>
        <Select v-model="add_job_data.fuwu_tax_status" style="width:200px">
          <Option v-for="item in fuwu_jiesuan_options" :value="item.value" :key="item.value">{{ item.label }}
          </Option>
        </Select>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
  name: "project_job",
  data() {
    return {
      project_id: "",
      project_name: "",
      job_list: [],
      add_job_show: false,
      add_job_model_title: '添加岗位结算信息',
      job_status_options: [
        { 'label': '小时工', 'value': 'xiaoshi' },
        { 'label': '派遣工', 'value': 'paiqian' },
        { 'label': '计件工', 'value': 'jijian' },
        { 'label': '社保代理', 'value': 'shebaodaili' },
        { 'label': '代发工资', 'value': 'daifagongzi' },
      ],
      xiaoshigong_jiesuan_options: [
        { 'label': '不含税', 'value': 0 },
        { 'label': '含税（差额）', 'value': 1 },
        { 'label': '含税（全额）', 'value': 2 },
      ],
      fuwu_jiesuan_options: [
        { 'label': '含税（差额）', 'value': 1 },
        { 'label': '含税（全额）', 'value': 2 },
      ],
      add_job_data: {
        job_id: '',
        job_name: "",
        job_status: 'xiaoshi',
        fafang_money: '',
        jiesuan_money: '',
        xiaoshigong_tax_status: 0,

        fuwu_money: '',
        fuwu_desc: '',
        fuwu_tax_status: 2,

        jijian_jiesuan_ratio: '',
        jijian_tax_status: 2,


      },
      job_exist: 0
    };
  },
  methods: {

    click_editor_job(item) {
      console.log(item)
      this.click_update_job(item)
    },

    click_item(item, i) {
      if (item.is_hide == 1) {
        item.is_hide = 0

      } else {
        item.is_hide = 1
      }
    },
    add_job_confirm() {
      console.log("点击添加");
      var that = this;
      var obj = {
        job_name: this.add_job_data.job_name,
        job_id:this.add_job_data.job_id,
        project_id: this.project_id,
        job_status: this.add_job_data.job_status,
        fafang_money: this.add_job_data.fafang_money,
        jiesuan_money: this.add_job_data.jiesuan_money,
        xiaoshigong_tax_status: this.add_job_data.xiaoshigong_tax_status,

        fuwu_money: this.add_job_data.fuwu_money,
        fuwu_desc: this.add_job_data.fuwu_desc,
        fuwu_tax_status: this.add_job_data.fuwu_tax_status,

        jijian_jiesuan_ratio: this.add_job_data.jijian_jiesuan_ratio,
        jijian_tax_status: this.add_job_data.jijian_tax_status

      };
      http("post", process.env.VUE_APP_HOST + "/my_project/project_job_add", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_job_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_update_job(item) {
      this.add_job_show = true;
      this.add_job_model_title = '岗位结算信息更新'
      this.add_job_data.job_id = item.job_id

      this.add_job_data.job_status = item.job_status
      this.add_job_data.job_name = item.job_name
      // 小时工
      if (item.job_status == 'xiaoshi') {
        this.add_job_data.fafang_money = item.fafang_money
        this.add_job_data.jiesuan_money = item.jiesuan_money
        this.add_job_data.xiaoshigong_tax_status = item.xiaoshigong_tax_status
      }

      //计件工
      if (item.job_status == 'jijian') {
        this.add_job_data.jijian_jiesuan_ratio = item.jijian_jiesuan_ratio
        this.add_job_data.jijian_tax_status = item.jijian_tax_status
      }


      // 派遣工、社保代理、代发工资
      if (item.job_status == 'paiqian' || item.job_status == 'shebaodaili' || item.job_status == 'daifagongzi') {
        this.add_job_data.fuwu_money = item.fuwu_money
        this.add_job_data.fuwu_desc = item.fuwu_desc
        this.add_job_data.fuwu_tax_status = item.fuwu_tax_status
      }

    },

    
    zhudong_add_job() {
      
      this.add_job_data.job_id = ''
      this.add_job_model_title = '添加岗位结算信息'
      this.add_job_show = true;
    },


    click_add_job(project_id) {
      if(project_id){
        this.project_id= project_id
      }
      
      this.add_job_data.job_id = ''
      this.add_job_model_title = '添加岗位结算信息'
      this.add_job_show = true;
    },

    del_job_confirm(job_id) {
      console.log("点击添加");
      var that = this;
      var obj = {
        job_id: job_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/project_job_del", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_job_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_close_job(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>正在删除岗位，是否继续？</p>",
        onOk: () => {
          that.del_job_confirm(item.job_id);
        },
        onCancel: () => { },
      });
    },

    open(project_id, project_name) {
      console.log('查询岗位数据')
      this.project_id = project_id;
      this.project_name = project_name;

      this.get_job_list();
    },

    get_job_list() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http("post", process.env.VUE_APP_HOST + "/my_project/project_job_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.job_list = res.data.job_list;
            that.job_exist = res.data.job_exist
            if (that.job_exist == 0) {
              // that.$Modal.error({
              //   title: '提示',
              //   content: '<p>当前项目还未完善【岗位结算信息】，请及时完善结算数据！</p>',
              //   onOk: () => {

              //   },
              //   onCancel: () => {
              //   }
              // });
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.job_card_option{
  display: flex;
  height: 13px;
  justify-content: flex-end;
}

.hide_icon {
  margin-left: 3px;
  font-size: 15px;
  color: #d4d4d4
}

.add_job_txt {
  font-size: 13px;
  color: #888;
  line-height: 30px;
  margin-right: 10px;
  margin-left: 10px
}

.input_job_name {
  width: 120px;
  flex-shrink: 0;
}

.job_name_div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.close_span {
  font-size: 15px;
  right: 3px;
  color: red;
}

.editor_span {
  font-size: 15px;
  margin-right: 5px;
  color: rgb(6, 27, 214);
}

.editor_span:hover {
  font-weight: 600;
}

.job_card_list {
  padding: 10px 0 0 10px;
  display: flex;
  flex-wrap: wrap;
}

.job_moeny {
  color: #f82323
}

.job_status_fmt {
  color: #959595;
  display: flex;
  align-items: center;
}

.job_name {
  font-weight: 600;
}

.job_card {
  position: relative;
  font-size: 13px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  padding: 0px 5px 5px 10px;
  border-radius: 3px;
  border: 1px solid #ececec;
  margin-right: 10px;
  margin-bottom: 10px;
}

.job_card_add:hover {
  border: 1px solid #0466dd;
}

.job_card_add {
  position: relative;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  border-radius: 3px;
  border: 1px solid #ececec;
  margin-right: 10px;
  margin-bottom: 10px;
}

.job_card:hover .add_icon {
  color: #fff;
  font-weight: 600;
}

.job_card:hover .close_span {
  /* color: #fff; */

  font-weight: 600;
}

.add_icon {
  color: #0466dd;
}

.job_card:hover {
  cursor: pointer;
  /* background: #0466dd; */
  border: 1px solid #0466dd;
}
</style>
